/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Adm_Err_External_Id_TakenInputs */

const en_adm_err_external_id_taken = /** @type {(inputs: Adm_Err_External_Id_TakenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Another group already uses this SSO group name.`)
};

const de_adm_err_external_id_taken = /** @type {(inputs: Adm_Err_External_Id_TakenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eine andere Gruppe nutzt diesen SSO-Gruppennamen bereits.`)
};

/**
* | output |
* | --- |
* | "Another group already uses this SSO group name." |
*
* @param {Adm_Err_External_Id_TakenInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const adm_err_external_id_taken = /** @type {((inputs?: Adm_Err_External_Id_TakenInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Adm_Err_External_Id_TakenInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_adm_err_external_id_taken(inputs)
	return en_adm_err_external_id_taken(inputs)
});